module.exports = __webpack_public_path__ + "assets/images/logo-healthid-lab_sbg.ab020625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-healthid-lab_sbg.png
// module id = 1392
// module chunks = 1